export default __webpack_public_path__ + "static/media/twitter.ec69e286.svg";